import { onRouterTransitionStart } from '@datadog/browser-rum-nextjs';

export { onRouterTransitionStart };

import { initDatadog } from './src/utils/datadog/init';

initDatadog();
